<div class="nha-sa-location-card" [formGroup]="formGroup"
  [ngClass]="{'nha-sa-location-card-selected': isSelected, 'nha-hide nha-show@md ': hiddenMobile}">
  <div class="nha-sa-location-card-content" (click)="selectSchool()">
    <span class="distance">{{schoolControl.get('milesAway').value}} mi</span>
    <h5 class="nha-sa-location-card-name">{{schoolControl.get('schoolName').value}}</h5>
    <div *ngIf="!schoolControl.get('isApplying').value">
      <span class="subtitle">{{schoolControl.get('address').value}}, {{schoolControl.get('city').value}}</span>
    </div>
    <div *ngIf="schoolControl.get('isApplying').value" class="added-indicator">
      <span class="subtitle"><span class="fa fa-check"></span> {{appContent.resourceStrings["nha.sa.applyingconfirmationcheckmark"]}}
      </span>
    </div>
  </div>
  <div class="nha-hide@md">
    <div *ngIf="schoolControl.get('isApplying').value" class="remove-btn-wrap">
      <button class="remove-btn" (click)="removeSchoolToApply()"><span class="fa fa-trash"></span> {{appContent.resourceStrings["nha.sa.removeschool"]}}</button>
    </div>
    <a *ngIf="!schoolControl.get('isApplying').value" (click)="addSchoolToApply()" class="nha-white-link add-btn">
      <span class="fa fa-plus-circle"></span> {{appContent.resourceStrings["nha.sa.addtoapplyadditionalschool"]}}
    </a>
  </div>
</div>
